module.exports = __webpack_public_path__ + "img/paper_empty.ca50bafb.png";